/**
 * Sent when the player has started a dialog
 *
 * @param eventProperties.dialog_id ID of the dialog
 * @param eventProperties.times_seen Number of times the player has seen the dialog, starting from 1. Used to check if players see the same dialog too many times
 * @param eventProperties.withFriends Whether a friend’s pet was together or not
 * @param eventProperties.friendID User ID of the friend player the player is visiting
 * @param eventProperties.friendPetID Pet ID (species) of the friend’s pet
 * @param eventProperties.friendPetStomach Value of the stomach gauge of the friend’s pet
 * @param eventProperties.friendPetLove Value of the love gauge of the friend’s pet
 * @param eventProperties.friendDirtiness Value of the dirtiness of the friend’s pet
 * @param eventProperties.friendUrine Value of the urine of of the friend’s pet
 * @param eventProperties.friendStress Value of the stress of the friend’s pet
 * @param eventProperties.friendToothAcidity Value of the tooth_acidity of the friend’s pet
 * @param eventProperties.friendAge Age of the friend’s pet
 * @param eventProperties.friendPlayerLevel Player level of the friend
 * @param eventProperties.visits Number of times the player has visited the friend including the current visit
 * @param eventProperties.visited Number of times the player has been visited by the friend
 */
export const getDialogStartEvent = (
  eventProperties:
    | {
        dialog_id: string;
        times_seen: number;
        withFriends: false;
      }
    | {
        dialog_id: string;
        times_seen: number;
        withFriends: true;
        friendID: string;
        friendPetID: string;
        friendPetStomach: number;
        friendPetLove: number;
        friendDirtiness: number;
        friendUrine: number;
        friendStress: number;
        friendToothAcidity: number;
        friendAge: number;
        friendPlayerLevel: number;
        visits: number;
        visited: number;
      },
) => ({
  eventType: 'DialogStart',
  eventProperties,
});
